import { getEnv } from '@src/apis/shared';
import type { WebFingerResponse, WebFingerIdpResult } from '@src/types';

export const lookupIdp = async (email: string): Promise<WebFingerIdpResult | null> => {
  const oktaBaseUri = getEnv('OKTA_BASE_URI') as string;

  if (!oktaBaseUri) {
    throw new Error('OKTA_BASE_URI is not configured');
  }

  const resource = `okta:acct:${email}`;
  const params = new URLSearchParams({
    resource,
    rel: 'okta:idp',
  });

  const response = await fetch(
    `${oktaBaseUri}/.well-known/webfinger?${params.toString()}`,
    {
      method: 'GET',
      headers: { Accept: 'application/jrd+json' },
    }
  );

  if (!response.ok) {
    throw new Error(`WebFinger lookup failed: ${response.statusText}`);
  }

  const data: WebFingerResponse = await response.json();

  const idpLink = data.links?.find(
    link => link.rel === 'okta:idp' && link.properties?.['okta:idp:id']
  );

  if (!idpLink) {
    return null;
  }

  return {
    idpId: idpLink.properties!['okta:idp:id']!,
    idpType: idpLink.properties!['okta:idp:type'] || 'UNKNOWN',
    idpName: idpLink.titles?.und || 'External Identity Provider',
  };
};
